import { createAsyncThunk } from '@reduxjs/toolkit';
import * as Sentry from "@sentry/gatsby"
import { Deal } from '../../Interfaces/deal';
import instance from '../../utils/Axios';

export const getDealFromId = createAsyncThunk<
  any,
  string | number
>('deal/getDealById', async (dealId) => {
  const response = await instance.get(`deals/${dealId}/`);

  return response.data;
})

export interface CustomerDealProps {
  vid: string | number,
  page?: number,
}

export interface CustomerDeals {
  count: number,
  next: string,
  previous: string,
  results: Deal[],
}

export const getDealsFromCustomerId = createAsyncThunk<CustomerDeals, CustomerDealProps>(
  'deal/getDealsFromCustomerId',
  async (props) => {
    try {
      const response = await instance.get(`/contacts/deals/${props.vid}/${props.page ? `?page=${props.page}` : ''}`);
      return response.data;
    } catch (err) {
      Sentry.captureException(err);
      const typedErr: any = err;
      if (typedErr.response.status === 500) {
        return { errors: { '500': 'There was an error fetching customer deals. Please try again.' }}
      }
      return { errors: typedErr.response.data }
    }
  }
)



export const getCustomerDealsFromURL = createAsyncThunk<CustomerDeals, string>(
  'deal/getCustomerDealsFromURL',
  async (url) => {
    try {
      const response = await instance.get(url);
      return response.data;
    } catch (err) {
      Sentry.captureException(err);
      const typedErr: any = err;
      if (typedErr.response.status === 500) {
        return { errors: { '500': 'There was an error fetching customer deals. Please try again.' }}
      }
      return { errors: typedErr.response.data }
    }
  }
)
